import { useEffect, useState, useRef, useMemo } from "react";
import api from "../../../../services/api";
import apiPublic from "../../../../services/apiPublic";
import { streamPost } from "../../../../services/apiStream";
import { EasyMapsResponse as EasyMapsResponseProto } from "../../../../schemas/onus";
import {
  Stack,
  Snackbar,
  Alert,
  CircularProgress,
  Box,
  Typography,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import { useOutletContext, useParams, useNavigate } from "react-router-dom";
import "../../../../componentes/leaflet-migrations";
import "../../../../componentes/leaflet-fullscreen/Leaflet.fullscreen";
import LoadingUpdate from "../../../../componentes/easyMaps/loadingUpdate";
import LeafletMap from "./leaflatMapa/index";
import SliderBarMapsOnus from "../../../../componentes/easyMaps/sideBarEasyMapsOnus";
import getCentroid from "../utils/getCentroid";
import { getLocalMapConfig, applyLocalOverride } from "../../../../utils/easyMapsLocalConfig";
import { MapaContext } from "../../../../contexts/mapaContext";
import AlertModal from "../../../../componentes/alertModal";

const EasyMapsResponse = EasyMapsResponseProto as any;
const LoadingUpdateComponent = LoadingUpdate as React.FC<any>;

const isMobile =
  (navigator as any).userAgentData?.mobile === true ||
  window.matchMedia("(pointer: coarse)").matches;

function isValidCoord(c: any) {
  const lat = Number(c.lat);
  const long = Number(c.long);
  return (
    c &&
    !isNaN(lat) &&
    !isNaN(long) &&
    lat >= -90 &&
    lat <= 90 &&
    long >= -180 &&
    long <= 180
  );
}

interface OutletContextType {
  config: any;
  configLayer: Record<string, string>;
  setConfigLayer: React.Dispatch<React.SetStateAction<Record<string, string>>>;
}

interface MapaGeolocalizadoONUsProps {
  socketCliente?: any;
  isPublic?: boolean;
}

export default function MapaGeolocalizadoONUs({
  socketCliente,
  isPublic = false,
}: MapaGeolocalizadoONUsProps) {
  const mapRef = useRef<any>(null);
  const theme = useTheme();
  const navigate = useNavigate();
  const [snackbar, setSnackbar] = useState<any>(null);
  const [openAccessDenied, setOpenAccessDenied] = useState(false);
  const [produtos, setProdutos] = useState(false);
  const [map, setMap] = useState<any>(null);
  const [invalidElements, setInvalidElements] = useState<any[]>([]);

  const [ctosMap, letCtosMap] = useState<Map<string, any>>(new Map());
  const [onusMap, letOnusMap] = useState<Map<string, any>>(new Map());
  const [ctosInvalidMap, setCtosInvalidMap] = useState<Map<string, any>>(
    new Map(),
  );
  const [onusInvalidMap, setOnusInvalidMap] = useState<Map<string, any>>(
    new Map(),
  );

  const [elements, setElements] = useState<any[]>([]);

  const [elementSelected, setElementSelected] = useState<any>(null);
  const [elementONUSelected, setElementONUSelected] = useState<any>(null);
  const [dataONUS, setDataONUS] = useState<any>(null);
  const [connectionSelected, setConnectionSelected] = useState<any>(null);
  const [connections, setConnections] = useState<Map<string, any>>(new Map());
  const [fullScreem, setFullScreem] = useState(false);
  const [mapas, setMapas] = useState<any[]>([]);
  const [editMode, setEditMode] = useState(false);
  const [iconsElements, setIconsElements] = useState<any[]>([]);
  const [loadingMap, setLoadingMap] = useState(true);
  const [loadingDetails, setLoadingDetails] = useState(false);
  const [checkChanges, setCheckChanges] = useState(false);
  const [isDateRecent, setIsDateRecent] = useState(true);
  const [staleHosts, setStaleHosts] = useState<string[]>([]);
  const [sinc, setSinc] = useState(false);
  const sincRef = useRef(false);
  const streamingRef = useRef(false);
  const [collapse, setCollapse] = useState(false);
  const [configurationMap, setConfigurationMap] = useState<any>(null);
  const [cities, setCities] = useState<Record<string, any>>({});
  const isSmall = useMediaQuery(theme.breakpoints.down("md"));
  const { config, configLayer, setConfigLayer } =
    useOutletContext<OutletContextType>();
  const [citiesFilter, setCitiesFilter] = useState<any[]>([]);
  const currentSerialRef = useRef<string | null>(null);
  const { id } = useParams<{ id: string }>();

  const latLngZoomFromUrl = useMemo(() => {
    const url = new URL(window.location.href);
    const lat = url.searchParams.get("lat");
    const lng = url.searchParams.get("lng");
    const zoom = url.searchParams.get("zoom");
    return { lat, lng, zoom };
  }, []);

  const allElementsMap = useMemo(() => {
    return new Map([
      ...onusMap,
      ...ctosMap,
      ...ctosInvalidMap,
      ...onusInvalidMap,
    ]);
  }, [onusMap, ctosMap, ctosInvalidMap, onusInvalidMap]);

  useEffect(() => {
    setCollapse(isSmall);
  }, [isSmall]);

  useEffect(() => {
    if (config && id) {
      handleApiGetElements(id);
    }
  }, [config, id]);

  useEffect(() => {
    if (!config) return;
    // Redireciona apenas quando NÃO há nenhuma fonte cadastrada. Todas elas
    // (QuestDB incluído) são entradas de `erpBancos`.
    const ftth = config?.configuracoes?.ftth;
    const hasSource = Array.isArray(ftth?.erpBancos) && ftth.erpBancos.length > 0;
    if (!hasSource) {
      navigate("/easyMaps");
    }
  }, [config?.configuracoes?.ftth]);

  useEffect(() => {
    if (!map || !config) return;
    if (!configurationMap) {
      const defaults = {
        animacao: config?.configuracoes?.ftth?.animacao,
        camadaFTTH: {
          filtros: config?.configuracoes?.ftth?.camadaFTTH?.filtros,
        },
        esconderOnu: config?.configuracoes?.ftth?.esconderOnu,
        showOnusWithoutCto: config?.configuracoes?.ftth?.showOnusWithoutCto,
      };
      const local = !isPublic ? getLocalMapConfig(id) : null;
      setConfigurationMap({
        configuracoes: local ? { ...defaults, ...local } : defaults,
      });
    }
  }, [map, config]);

  const handleCollapse = () => {
    setCollapse(!collapse);
  };

  const handleFullscreen = (value: boolean) => {
    setFullScreem(value);
    if (!isMobile) setCollapse(value);
  };

  const styles = useMemo(
    () => ({
      fullScreem: {
        position: "fixed",
        zIndex: 1500,
        width: "100dvw",
        height: "100dvh",
        left: 0,
        top: 0,
        backgroundColor: theme.palette.background.default,
      },
      noFullScreem: {
        position: "relative",
        ml: { xs: "0px", md: collapse ? "0px" : "340px" },
        width: {
          xs: "100dvw",
          md: "calc(100dvw - " + (collapse ? "0px" : "340px") + ")",
        },
        height: { xs: "calc(100dvh - 60px)", sm: "calc(100dvh - 67px)" },
      },
      loadingMap: {
        position: "absolute",
        zIndex: 1000,
        width: "100%",
        height: "100%",
        backgroundColor:
          theme.palette.mode !== "dark" ? "#e0e0e093" : "#00000093",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        gap: 4,
      },
    }),
    [theme, collapse],
  );

  useEffect(() => {
    if (elementSelected == null || editMode == true) return;
    const isCto = elementSelected?.tipoElemento === "cto";
    setElementSelected(() =>
      isCto ? ctosMap.get(elementSelected.id) : onusMap.get(elementSelected.id),
    );
  }, [ctosMap, onusMap]);

  useEffect(() => {
    if (connectionSelected == null || checkChanges) return;
    setConnectionSelected(connections.get(connectionSelected.id));
  }, [connections]);

  useEffect(() => {
    setLoadingMap(true);
    inicializeMap();
  }, [id]);

  useEffect(() => {
    if (!configLayer?.[id!]) {
      setConfigLayer((configLayer) => ({
        ...configLayer,
        [id!]: "ftth",
      }));
    }
    const timeInterval = config?.configuracoes?.ftth?.atualizacao || 5 * 60000;

    const interval = setInterval(() => {
      handleApiGetElements(id!, true);
    }, timeInterval);

    return () => {
      if (interval) {
        clearInterval(interval);
      }
    };
  }, [id, config]);

  const getSerial = (id: string) => (id ?? "").replace(/_onu$/i, "").trim();

  useEffect(() => {
    const elId = elementONUSelected?.id;
    const linkId = elementONUSelected?.linkId;

    if (!elId) return;

    const serial = getSerial(elId).toUpperCase();
    currentSerialRef.current = serial;

    setDataONUS(null);

    const ctrl = new AbortController();

    (async () => {
      try {
        const resp = await api.post(
          "/easyMaps/onus/find",
          { onuId: serial, linkId: linkId },
          { signal: ctrl.signal },
        );

        const payload = resp?.data;
        if (!payload) {
          setDataONUS({});
          return;
        }

        const arr = Array.isArray(payload) ? payload : [payload];

        const match = arr.find(
          (o: any) =>
            (o?.serialOnu ?? o?.serialONu ?? "").trim().toUpperCase() ===
            serial,
        );

        if (currentSerialRef.current !== serial) return;

        setDataONUS(match ?? {});
      } catch (error: any) {
        const aborted =
          error?.name === "AbortError" ||
          error?.name === "CanceledError" ||
          error?.code === "ERR_CANCELED" ||
          ctrl.signal.aborted;

        if (aborted) return;

        console.error(error);
        setDataONUS({});
        setSnackbar?.({
          children: `Error: ${
            error?.response?.data?.error ||
            "Não foi possível buscar dados da ONU"
          }`,
          severity: "error",
        });
      }
    })();

    return () => {
      ctrl.abort();
    };
  }, [elementONUSelected?.id]);

  async function inicializeMap() {
    try {
      await handleApiGetMap(id!);
    } catch (e: any) {
      if (e?.response?.status === 403) return;
      throw e;
    }
    await Promise.all([getIconDB(), handleApiGetElements(id!)]);
  }

  async function handleApiGetMap(id: string) {
    try {
      let response;
      if (isPublic) {
        response = await apiPublic.post("/easyMaps/public/map/findMapById", {
          mapId: id,
        });
      } else {
        response = await api.post("/easyMaps/map/findMapById", {
          mapId: id,
        });
      }

      if (response.data.status === "Error") {
        setSnackbar({
          children: " Não foi possível buscar o mapa",
          severity: "error",
        });
      } else {
        if (response.data.tipo != 3) navigate("/easyMaps");
        else {
          const { ConfigMapEasyMaps, ...map } = response.data;
          setMap(map);
          if (!isPublic && ConfigMapEasyMaps) {
            const local = getLocalMapConfig(id);
            setConfigurationMap(
              local
                ? applyLocalOverride(ConfigMapEasyMaps, local)
                : ConfigMapEasyMaps,
            );
          } else {
            setConfigurationMap(ConfigMapEasyMaps);
          }
        }
      }
    } catch (error: any) {
      console.error(error);
      if (error?.response?.status == 403) {
        setOpenAccessDenied(true);
        throw error;
      }
      if (error?.response?.status == 404) navigate("/easyMaps/notFound");
      setSnackbar({
        children: `Error:${
          error?.message || "Error: Não foi possível se conectar com o servidor"
        } `,
        severity: "error",
      });
    }
  }

  async function handleApiGetElements(id: string, isResync = false) {
    if (sincRef.current) return;

    try {
      sincRef.current = true;
      setSinc(true);

      const OnusMap = new Map<string, any>();
      const CtosMap = new Map<string, any>();
      const ConnectionsMap = new Map<string, any>();
      const OnusInvalidMap = new Map<string, any>();
      const CtosInvalidMap = new Map<string, any>();
      let mergedCities: Record<string, any> = {};
      let dateRecent = false;
      let outdatedElementIds: string[] = [];
      const allWarningUrls: string[] = [];
      let firstChunk = true;
      const endpoint = isPublic
        ? "/easyMaps/public/onus/findMany"
        : "/easyMaps/onus/findMany";

      await streamPost(
        endpoint,
        { mapId: id },
        (frame) => {
          const msg = EasyMapsResponse.decode(frame);
          const chunk = EasyMapsResponse.toObject(msg, {
            enums: String,
            longs: Number,
            defaults: true,
          });

          chunk.elements?.forEach((el: any) => {
            if (el.tipoElemento === "onu") OnusMap.set(el.id, el);
            else if (el.tipoElemento === "cto") CtosMap.set(el.id, el);
          });

          chunk.invalidElements?.forEach((el: any) => {
            if (el.tipoElemento === "onu") OnusInvalidMap.set(el.id, el);
            else if (el.tipoElemento === "cto") CtosInvalidMap.set(el.id, el);
          });

          chunk.connections?.forEach((conn: any) =>
            ConnectionsMap.set(conn.id, conn),
          );

          if (chunk.cities) Object.assign(mergedCities, chunk.cities);
          if (chunk.isDateRecent) dateRecent = true;
          if (chunk.outdatedElementIds.length > 0 && !dateRecent) {
            outdatedElementIds = chunk.outdatedElementIds;
          }
          if (chunk.warningUrls?.length > 0)
            allWarningUrls.push(...chunk.warningUrls);

          if (firstChunk) {
            if (!isResync) {
              streamingRef.current = true;
              setLoadingMap(false);
              setLoadingDetails(true);
            }
            firstChunk = false;
          }

          // Carga inicial: progressivo para elementos aparecerem enquanto a overlay "ajustando detalhes" está visível.
          // Re-sincronização: sem atualização intermediária para não piscar.
          if (!isResync) {
            letCtosMap(new Map(CtosMap));
            letOnusMap(new Map(OnusMap));
            setCtosInvalidMap(new Map(CtosInvalidMap));
            setOnusInvalidMap(new Map(OnusInvalidMap));
          }
        },
        isPublic,
      );

      if (allWarningUrls.length > 0) {
        setSnackbar({
          children: `Warning: A(s) URL(s): ${allWarningUrls.join()} falharam ao buscar os dados`,
          severity: "warning",
        });
      }

      // Connections/cities/date sempre atômicos ao final.
      // Re-sincronização: CTOs/ONUs também atômicos para evitar piscar.
      setCities(mergedCities);
      setIsDateRecent(dateRecent);
      setStaleHosts(outdatedElementIds);
      setConnections(new Map(ConnectionsMap));
      if (isResync) {
        letCtosMap(new Map(CtosMap));
        letOnusMap(new Map(OnusMap));
        setCtosInvalidMap(new Map(CtosInvalidMap));
        setOnusInvalidMap(new Map(OnusInvalidMap));
      } else {
        streamingRef.current = false;
        setLoadingDetails(false);
      }
    } catch (error: any) {
      setLoadingMap(false);
      setSnackbar({
        children: `Error: ${
          error?.response?.data?.error ||
          "Não foi possível se conectar com o servidor"
        } `,
        severity: "error",
      });
    } finally {
      streamingRef.current = false;
      setSinc(false);
      sincRef.current = false;
    }
  }
  async function getIconDB() {
    try {
      let response;
      if (isPublic) {
        response = await apiPublic.get("/easyMaps/public/img/findMany");
      } else {
        response = await api.get("/easyMaps/img/findMany");
      }

      if (response.data.status === "Error") {
        setSnackbar({
          children: "Error: Não foi possível buscar os icons",
          severity: "error",
        });
      } else {
        setIconsElements(response.data);
      }
    } catch (error: any) {
      console.error(error);
      setSnackbar({
        children: `Error:${
          error?.message || "Error: Não foi possível se conectar com o servidor"
        } `,
        severity: "error",
      });
    }
  }

  const coordinates = useMemo(
    () =>
      [...elements.values()].map((el) => el.coordenadas).filter(isValidCoord),
    [elements],
  );

  const boundsCoordinates = useMemo(() => {
    if (coordinates.length > 0) {
      return coordinates.map(
        (c: any) => [Number(c.lat), Number(c.long)] as [number, number],
      );
    }
    return null;
  }, [coordinates]);

  const centerCoordinates = useMemo((): [number, number] => {
    if (latLngZoomFromUrl.lat && latLngZoomFromUrl.lng)
      return [Number(latLngZoomFromUrl.lat), Number(latLngZoomFromUrl.lng)];
    const res = getCentroid(coordinates);
    if (
      res &&
      typeof res.lat === "number" &&
      typeof res.long === "number" &&
      !isNaN(res.lat) &&
      !isNaN(res.long)
    ) {
      return [res.lat, res.long];
    }
    return [-10, -48];
  }, [coordinates]);

  return (
    <MapaContext.Provider
      value={
        {
          mapId: id,
          tipo: "ftth",
          configurationMap,
          setConfigurationMap,
          setSnackbar,
          snackbar,
          isPublic,
          cities,
          citiesFilter,
          setCitiesFilter,
          ctosInvalidMap,
          onusInvalidMap,
          ctosMap,
          onusMap,
          allElementsMap,
          connections,
          loadingDetails,
          setLoadingDetails: (v: boolean) => {
            if (!v && streamingRef.current) return;
            setLoadingDetails(v);
          },
          dataONUS,
          iconsElements,
          elementSelected,
        } as any
      }
    >
      <Stack direction="row">
        {!fullScreem && (
          <SliderBarMapsOnus
            map={map}
            iconsElements={iconsElements}
            mapRef={mapRef}
            configLocal={configurationMap?.configuracoes?.ftth}
            config={config}
            collapse={collapse}
            handleCollapse={handleCollapse}
          />
        )}
        <Stack sx={!fullScreem ? styles.noFullScreem : styles.fullScreem}>
          {(loadingMap || loadingDetails) && (
            <Box sx={styles.loadingMap}>
              <CircularProgress size="50px" disableShrink />
              <Typography
                fontSize="14px"
                color={theme.palette.color.textEasyMaps}
              >
                {loadingDetails
                  ? "Estamos ajustando os últimos detalhes…"
                  : "Só um momento, carregando os dados do mapa…"}
              </Typography>
            </Box>
          )}

          <LoadingUpdateComponent
            visible={sinc && !(loadingMap || loadingDetails)}
            elementSelected={!!elementSelected}
            rulerMode={isSmall && citiesFilter.length > 0}
            customStyle={undefined}
          />

          <LeafletMap
            setFullScreem={handleFullscreen}
            fullScreem={fullScreem}
            socketCliente={socketCliente}
            ref={mapRef}
            elements={elements}
            invalidElements={invalidElements}
            connections={JSON.parse(
              JSON.stringify(connections ? connections : []),
            )}
            setElementSelected={setElementSelected}
            setElementONUSelected={setElementONUSelected}
            connectionSelected={connectionSelected}
            setConnectionSelected={setConnectionSelected}
            elementSelected={elementSelected}
            elementONUSelected={elementONUSelected}
            iconsElements={iconsElements}
            setIconsElement={setIconsElements}
            mapId={id}
            title={map?.titulo}
            element={editMode ? elementSelected : null}
            setElements={setElements}
            setConnections={setConnections}
            produtos={produtos}
            api={api}
            setSnackbar={setSnackbar}
            mapas={mapas}
            setMapas={setMapas}
            editMode={editMode}
            setEditMode={setEditMode}
            checkChanges={checkChanges}
            setCheckChanges={setCheckChanges}
            dataONUS={dataONUS}
            centerCoordinates={centerCoordinates}
            boundsCoordinates={boundsCoordinates}
            initialZoom={latLngZoomFromUrl.zoom}
            isDateRecent={isDateRecent}
            collapse={collapse}
            staleHosts={staleHosts}
          />
        </Stack>
      </Stack>
      {!!snackbar && (
        <Snackbar
          open
          onClose={() => setSnackbar(null)}
          autoHideDuration={2000}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        >
          <Alert {...snackbar} onClose={() => setSnackbar(null)} />
        </Snackbar>
      )}
      <AlertModal
        openModal={openAccessDenied}
        setOpenModal={setOpenAccessDenied}
        handleButton={() => navigate("/easyMaps/inicio")}
        severity="error"
        singleButton
        buttonText="Voltar"
        textContent="Você não tem permissão para acessar este mapa, solicite permissão ao administrador."
      />
    </MapaContext.Provider>
  );
}
